// This is a manifest file that'll be compiled into including all the files listed below.
// Add new JavaScript/Coffee code in separate files in this directory and they'll automatically
// be included in the compiled file accessible from http://example.com/assets/application.js
// It's not advisable to add code directly here, but if you do, it'll appear at the bottom of the
// the compiled file.

/* globals window, document, location, setTimeout, decodeURIComponent, encodeURIComponent,navigator */

// Define dependencies of sdk and say it depends on XDM, sdk.ui
define('sdk',["sdk/ui", "sdk/api"], function(UI, API){
  
  var sdk = {
    init: function(){
      API.getXdHandler();
    },
    ui: UI,
    api: API
  };
  return sdk;
});

